import {
  CancellationFlowDirection,
  CancellationFlowEventfulRouteIndex,
  EventfulRoute,
  SimpleRoute,
} from 'frontend/views/premium/cancellation/types';
import { trackClickWithElementId, trackPaymentActionWithId } from 'frontend/utils/nux';
import VueRouter from 'vue-router';

export const defaultNextEventfulRoute = (): EventfulRoute => {
  return {
    event: 'clicked_trial_cancellation_continue_cancellation_complete',
    payment_event: 'trial_stop_recurring',
    route: { name: 'payment_trial_cancel_complete' },
  };
};

export const defaultAbortEventfulRoute = (): EventfulRoute => {
  return {
    event: 'clicked_trial_cancellation_keep_trial_confirm',
    route: { name: 'explorations_menu' },
  };
};

export function cancellationApi<Type extends string>(
  eventfulRouteIndex: CancellationFlowEventfulRouteIndex<Type>,
) {
  type MaybeSurveyIdentifier = Type | null | undefined;

  function trackAction(action: CancellationFlowDirection, option: Type): void {
    const eventId: string = eventfulRouteIndex[option][action].event;
    trackClickWithElementId(eventId);
  }

  function trackPaymentAction(action: CancellationFlowDirection, option: Type): void {
    const paymentEventId = eventfulRouteIndex[option][action]?.payment_event;
    if (paymentEventId) {
      trackPaymentActionWithId(paymentEventId);
    }
  }

  function getRouteFor(action: CancellationFlowDirection, option: Type): SimpleRoute {
    return eventfulRouteIndex[option][action].route;
  }

  async function handleTrackedRedirect(
    direction: CancellationFlowDirection,
    option: MaybeSurveyIdentifier,
    router: VueRouter,
  ) {
    if (!option) return;
    trackAction(direction, option);
    trackPaymentAction(direction, option);
    await router.push(getRouteFor(direction, option));
  }

  return {
    handleTrackedRedirect,
  };
}
